module.exports = __webpack_public_path__ + "static/media/icon_filter.03797413.svg";